// Header.js
import React from 'react';
import { Link } from 'react-router-dom'; // If using React Router
import './Header.css';
import Button from '../../material3/components/Button';

const Header = () => {
  const handlePlayGame = (event) => {
    event.preventDefault();
    console.log('button clicked');
    window.open('https://play-grandquiz.chellobee.com', '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="fixed-header">
      <div className='header-content'>
        <div className='brand-box'>
          <Link to="/"><img className='logo' src={process.env.PUBLIC_URL + '/logo512.png'} alt='Vihana Matrimony' /></Link>
          <p>Vihana Matrimony</p>
        </div>
        <nav>
          <ul className='menu-items'>
            <li><Link to="/features">Why Vihana</Link></li>
            <li><Link to="/support">Support</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
